<div class="loading-screen-wrapper" *ngIf="loading">
    <div class="loading-screen-inner">
        Loading...
    </div>
</div>